import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { LanguageContext, DEFAULT_LANGUAGE } from './languageContext';

class LanguageProvider extends Component {
    constructor(props) {
        super(props);

        const { location: { search } } = props;
        const parsed = queryString.parse(search);

        this.state = { lang: parsed.lang || DEFAULT_LANGUAGE };
    }

    render() {
        const { children } = this.props;
        const { lang } = this.state;

        return (
            <LanguageContext.Provider value={lang}>
                {!!lang && children}
            </LanguageContext.Provider>
        );
    }
}

LanguageProvider.propTypes = {};
LanguageProvider.defaultProps = {};

export default withRouter(LanguageProvider);



// WEBPACK FOOTER //
// ./src/translations/LanguageProvider.js